import DiscountCodeSettings from '../../components/settings/DiscountCodeSettings';

export default DiscountCodeSettings;
